export const SHOW_HOTKEYS_MODAL = 'modals/SHOW_HOTKEYS_MODAL'
export const HIDE_HOTKEYS_MODAL = 'modals/HIDE_HOTKEYS_MODAL'
